import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { storeConsumeMasterTracking, StoresConsumeMasterModel } from 'app/ipd/models/ipdDashboardModel';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { read } from 'fs';
import * as moment from 'moment';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bulk-consumption',
  templateUrl: './bulk-consumption.component.html',
  styleUrls: ['./bulk-consumption.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BulkConsumptionComponent implements OnInit {
  destroybulk$: Subject<boolean> = new Subject<boolean>();
  private salesTypes: any[] = [];
  private filteredSalesTypes: Observable<any[]>;
  private filteredSLocation: Observable<any[]>;
  private filterpayor: Observable<any[]>;
  private filterbulkdeparment: Observable<any[]>;
  private filteredbulkDoctorArray: Observable<any[]>;
  private storeData: any[] = [];
  private getstoretemData: any[] = [];
  private viewconsmtiondata: any[] = [];
  private getstoreConsume: any[] = [];
  private getbatchnoData: any[] = [];
  private locationgetData: any[] = []
  private payorNames: any[] = [];
  private getbulkdeparment: any[] = [];
  private filteredStoreData: any[] = [];
  private ShowbulkDepName: any;
  private isDepartmentSelected: boolean = true;
  private storesConsumeMasterArray: StoresConsumeMasterModel = {};
  private filterText: string = '';
  isActive: boolean = true;

  private salesTypeControl1: FormControl;
  private locationControl1: FormControl;
  private gstCtrl: FormControl;
  private remarkCtrl: FormControl;
  private patientCtrl: FormControl;
  private payorControl1: FormControl;
  private bulkdepartmentControl: FormControl;
  private doctorCtrl: FormControl;
  private locationCtrl: FormControl;
  private partyCtrl: FormControl;

  editCache: any = {};
  totalAmount: number = 0;
  totalNetAmount: number = 0;
  roundedOffAmount: number = 0;
  roundoff: any = '1.2-2'
  roundoffLimit: any = '1.2-2'
  con_dynamiclabel: any
  con_saleQty: any
  con_BillNoGeneration: any
  con_autoBatch: any

  addedItems = [];
  selectedItem: any[] = [];
  storesConsumeItemDetails: any = [];


  searchbulkQuery: string = '';
  searchbarcodeQuery: string = '';
  searchbatchnoQuery: string = '';
  barcodeQuery: string = '';

  filteredbulkItemList: any[] = [];
  filteredbarcodeList: any[] = [];
  filterbatchcodeList: any[] = [];

  // Input field variables
  batchNo: any

  saleQuantity: number;
  discountPercentage: any;
  discountAmount: any;
  gstAmount: number = 0;
  decimalAmount: any;
  rateAmount: any;

  bulkStartDate: any;
  bulkEndDate: any;

  searchItemlist: any;
  searchbarcodelist: any
  selectedStockQty: any;
  constructor(
    private dialogRef: MatDialogRef<BulkConsumptionComponent>,
    private authService: AuthService,
    private ipdService: IPDService,
    private dashboardService: DashboardService,
    private opdvisitService: OpdVisitService,
    private datePipe: DatePipe
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getbulkDeptMaster();
    this.bulkdepControll();
    this.bulkdepartmentControl = new FormControl();
    this.locationControl1 = new FormControl();
    this.salesTypeControl1 = new FormControl();
    this.payorControl1 = new FormControl();
    this.doctorCtrl = new FormControl();
    this.gstCtrl = new FormControl();
    this.remarkCtrl = new FormControl();
    this.patientCtrl = new FormControl();
    this.doctorCtrl = new FormControl();
    this.locationCtrl = new FormControl();
    this.partyCtrl = new FormControl();
    if (this.getbulkdeparment.length > 0 && this.authService.masterdata.fK_DeptID != null) {
      this.ShowbulkDepName = this.getbulkdeparment.filter((item) => item.pkDeptId == this.authService.masterdata.fK_DeptID)[0]?.deptName
      this.bulkdepselect(0)
    }
    var rounfOff = this.opdvisitService.documentrul.filter(item => item?.propertyName == "RoundOff_Final");
    if (rounfOff[0].propertyValue != null && rounfOff[0].propertyValue != undefined) {
      this.roundoff = 1 + '.' + rounfOff[0]?.propertyValue + '-' + rounfOff[0]?.propertyValue
    }

    var roudOffLimit = this.opdvisitService.documentrul.filter(item => item?.propertyName == "RoudOffLimit");
    if (rounfOff[0].propertyValue != null && roudOffLimit[0].propertyValue != undefined) {
      this.roundoffLimit = 1 + '.' + roudOffLimit[0]?.propertyValue + '-' + roudOffLimit[0]?.propertyValue
    }

    var gstlabel = this.opdvisitService.documentrul.filter(item => item?.propertyName == "GST_OR_VAT");
    if (gstlabel[0].propertyValue != null && gstlabel[0].propertyValue != undefined) {
      this.con_dynamiclabel = gstlabel[0]?.propertyValue
    }

    var conSaleQty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "DefaultQtyForSales");
    if (conSaleQty[0].propertyValue != null && conSaleQty[0].propertyValue != undefined) {
      this.saleQuantity = conSaleQty[0]?.propertyValue
    }
  }

  getsaleobj(e) {
    var val = e.option.value;
    this.storesConsumeMasterArray.salesType = val;
  }

  getdoctorrobj(e) {
    var val = e.option.value;
    this.storesConsumeMasterArray.doctorName = val;
  }
  locationdata: any
  getlocationobj(e) {
    this.storesConsumeMasterArray.fK_ConsumeLocationID = e.id;
    this.storesConsumeMasterArray.locationName = e.value;
  }

  clearlocation(locID: any) {
    if (!locID) {
      this.storesConsumeMasterArray.fK_ConsumeLocationID = null;
    }
  }


  payordata: any
  getbulkpayorobj(e) {
    this.storesConsumeMasterArray.fK_PartyId = e.id;
    this.storesConsumeMasterArray.payorname = e.value;
  }


  getbulkDeptMaster() {
    this.ipdService.getDepartment(this.authService.Loggeduser.branchid).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
      this.getbulkdeparment = res;
    })
  }

  bulkdepControll() {
    this.bulkdepartmentControl = new FormControl();
    this.filterbulkdeparment = this.bulkdepartmentControl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterbulkdep(cat)
          : this.getbulkdeparment.slice()
      )
    );
  }

  // showAllbulkdep() {
  //   this.bulkdepartmentControl.setValue(this.bulkdepartmentControl.value);
  //   this.filterbulkdeparment = this.bulkdepartmentControl.valueChanges.pipe(
  //     startWith(""),
  //     map((value) => this.filterbulkdep(value))
  //   );
  // }
  showAllbulkdep() {
    const currentValue = this.bulkdepartmentControl.value || ""; // Fallback to an empty string if value is null or undefined
    this.bulkdepartmentControl.setValue(currentValue);
    this.filterbulkdeparment = this.bulkdepartmentControl.valueChanges.pipe(
      startWith(""),
      map((value) => this.filterbulkdep(value))
    );
  }

  filterbulkdep(value: any) {
    if (!value) {
      return this.getbulkdeparment; // Return all departments if value is null or undefined
    }

    const len = Object.keys(value).length;
    if (len > 9) {
      return this.getbulkdeparment.filter(
        (dep) => dep.deptName?.toLowerCase().indexOf(value) === 0
      );
    } else {
      return this.getbulkdeparment.filter(
        (dep) =>
          dep.deptName?.toLowerCase().indexOf(value?.toLowerCase()) === 0
      );
    }
  }

  initializeFilteredItemList() {
    this.filteredbulkItemList = this.searchItemlist;
  }
  initializeFilteredbatchnoList() {
    this.filterbatchcodeList = this.getbatchnoData;
  }

  filterStoreData() {
    const filterTextLower = this.filterText.toLowerCase();
    this.filteredStoreData = this.storeData.filter(template =>
      template.itemName.toLowerCase().includes(filterTextLower)
    );
  }

  temId: any;
  item_id: any
  loadTemplateData(temid: any, index) {
    this.temId = temid;
    this.ipdService.getTemdatastore(this.temId).subscribe((res: any) => {
      this.getstoretemData = this.getstoretemData.concat(res);
    })
    document.getElementById("templatebulkModal").style.display = "none";
  }


  templateModal() {
    this.ipdService.getStoreData(this.authService.Loggeduser.branchid).subscribe((res: any) => {
      if (res.length > 0) {
        this.storeData = res;
      }
    })
    document.getElementById("templatebulkModal").style.display = "block";
  }
  closeTemplateModal() {
    this.filterText = null;
    this.storeData = null;
    this.filteredStoreData = null;
    document.getElementById("templatebulkModal").style.display = "none";
  }


  filterlocationArray: Observable<any[]>
  initializeLocationcontrol() {
    this.locationCtrl = new FormControl(this.storesConsumeMasterArray.locationName || '');

    this.filterlocationArray = this.locationCtrl.valueChanges.pipe(
      startWith(this.storesConsumeMasterArray.locationName || ''),
      map((status) =>
        status
          ? this.filterlocation(status)
          : this.locationgetData.slice()
      )
    );
  }

  filterlocation(name: string): any[] {
    return this.locationgetData.filter((group) =>
      group.consumptionLocationName.toLowerCase().includes(name.toLowerCase())
    );
  }

  showAllLocations() {
    this.locationControl1.setValue(this.locationControl1.value);
    this.filteredSLocation = this.locationControl1.valueChanges.pipe(
      startWith(""),
      map((value) => this.filterlocation(value))
    );
  }

  doctorControll() {
    this.doctorCtrl = new FormControl();
    this.filteredbulkDoctorArray = this.doctorCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterdoctorfunction(cat)
          : this.opdvisitService.doctors.slice()
      )
    );
  }
  filterdoctorfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.opdvisitService.doctors.filter(
        (country) => country.userName?.toLowerCase().indexOf(name) === 0
      );
    } else {
      return this.opdvisitService.doctors.filter(
        (country) =>
          country.userName?.toLowerCase().indexOf(name?.toLowerCase()) === 0
      );
    }
  }

  deptId: any
  bulkdepselect(e) {
    if (e != 0) {
      const selectedDep = e.option.value;
      this.ShowbulkDepName = selectedDep;
    }

    const selectedDepartment = this.getbulkdeparment.find(dep => dep.deptName === this.ShowbulkDepName);
    this.deptId = selectedDepartment?.pkDeptId;

    if (this.deptId) {
      this.isDepartmentSelected = false;
      forkJoin({
        locationMaster: this.ipdService.getComlocationMst(this.authService.Loggeduser.branchid, this.deptId),
        saleType: this.ipdService.get_saletype(),
        // storeData: this.ipdService.getStoreData(this.authService.Loggeduser.branchid),
        templateData: this.ipdService.getTemdatastore(this.temId),
        partyData: this.ipdService.get_partytpa(),
        searchItem: this.ipdService.getSearchitem(this.deptId, 0),
        searchBarcode: this.ipdService.getSearchBarcode(this.deptId, 0),
        // storeConsume: this.ipdService.getStoresConsumeMaster(0, this.RegId, this.selectIpdId),

      }).subscribe(
        (results) => {
          this.salesTypes = results.saleType
          this.locationgetData = results.locationMaster
          // this.storeData = results.storeData
          this.payorNames = results.partyData
          this.getstoretemData = results.templateData
          // this.getstoreConsume = results.storeConsume

          this.searchItemlist = results.searchItem.map(item => ({
            ...item,
            isSelected: false // Initialize the selection state
          }));
          const defaultOption = this.salesTypes.find(saleType => saleType.name === "BulkConsumption");
          if (defaultOption) {
            this.storesConsumeMasterArray.salesType = defaultOption.name;
            this.salesTypeControl1.setValue(defaultOption.name);
          }
          this.searchbarcodelist = results.searchBarcode

          this.initializeFilteredItemList();
          this.initializeFilteredbatchnoList();
          this.saletypeControll();
          // this.locationControll();
          this.initializeLocationcontrol();
          // this.payorControl1l();
          this.initializepartyArray()
          this.showAllSaletype()
          this.doctorControll()
        },

        (error) => {
          console.error('Error in API calls:', error);
        }
      );
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "OK");
    }
  }

  saletypeControll() {
    this.salesTypeControl1 = new FormControl();
    this.filteredSalesTypes = this.salesTypeControl1.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filtersale(cat)
          : this.salesTypes.slice()
      )
    );
  }
  filtersale(value: any) {
    const len = Object.keys(value).length;
    if (len > 9) {
      return this.salesTypes.filter(
        (sale) => sale.name?.toLowerCase().indexOf(value) === 0
      );
    } else {
      return this.salesTypes.filter(
        (sale) =>
          sale.name?.toLowerCase().indexOf(value?.toLowerCase()) === 0
      );
    }
  }

  showAllSaletype() {
    this.salesTypeControl1.setValue(this.salesTypeControl1.value || 'BulkConsumption');
    this.filteredSalesTypes = this.salesTypeControl1.valueChanges.pipe(
      startWith(""),
      map((value) => this.filtersale(value))
    );
  }

  filterpartyArray: Observable<any[]>
  initializepartyArray() {
    this.partyCtrl = new FormControl(this.storesConsumeMasterArray.payorname || '');

    this.filterpartyArray = this.partyCtrl.valueChanges.pipe(
      startWith(this.storesConsumeMasterArray.payorname || ''),
      map((status) =>
        status
          ? this.filterparty(status)
          : this.payorNames.slice()
      )
    );
  }

  filterparty(name: string): any[] {
    return this.payorNames.filter((group) =>
      group.partyName.toLowerCase().includes(name.toLowerCase())
    );
  }

  clearpartyid(partyId: any) {
    if (!partyId) {
      this.storesConsumeMasterArray.fK_PartyId = null;
    }
  }

  searchitembulkModel() {
    if (this.deptId) {
      document.getElementById("searchbulkItemListDisplay").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "OK");
    }
  }

  closeitemListDisplay() {
    document.getElementById("searchbulkItemListDisplay").style.display = "none";
  }

  selecteditemStockQty: any;
  clearitem: any
  onRowDblClick(item: any) {
    this.selecteditemStockQty = item.totalStockQty;
    item.saleQuantity = 1;
    // this.addedItems.push(item)
    this.addedItems.push({ ...item })
    const pkitemId = item.pK_ItemID;
    if (pkitemId) {
      this.ipdService.getBatchitem(this.deptId, pkitemId).pipe(takeUntil(this.destroybulk$)).subscribe(
        (batchData) => {
          this.getbatchnoData = batchData;
        },
        (error) => console.error('Error fetching batchnoItem:', error)
      );
    }
    document.getElementById("searchbulkItemListDisplay").style.display = "none";
  }
  filterbulkItems() {
    if (!this.searchbulkQuery) {
      this.filteredbulkItemList = this.searchItemlist;
    } else {
      this.filteredbulkItemList = this.searchItemlist.filter(item =>
        item.itemName.toLowerCase().includes(this.searchbulkQuery.toLowerCase())
      );
    }
  }

  addConsumableItemsModal() {
    if (this.deptId) {
      document.getElementById("AddbulkConsumableItemsModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "ok");
    }
  }
  closeAddConsumableItemsModal() {
    document.getElementById("AddbulkConsumableItemsModal").style.display = "none";
    this.addedItems = [];
    this.getbatchnoData = [];
    // this.selectedStockQty = 0;
    this.selecteditemStockQty = null;
    this.selectedStockQty = null;
  }


  searchText: any;
  closeserchBulk() {
    document.getElementById("bulkSearchRecordModal").style.display = "none";
    this.bulkSearchrecords = [];
    this.filteredbulkArray = [];
    this.bulkStartDate = "";
    this.bulkEndDate = "";
  }
  serchBulk() {
    if (this.deptId) {
      document.getElementById("bulkSearchRecordModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Please Select Department First", "Ok");
    }
  }

  matchedBatch
  fkconsumeId: any
  private storesConsumeMasterTrackingarray: storeConsumeMasterTracking = {}
  populatebulkrecord(bulkrecord) {
    if (bulkrecord) {
      this.fkconsumeId = bulkrecord.pK_ConsumeId
      this.storesConsumeMasterArray.patientName = bulkrecord.patientName;
      this.billNo = bulkrecord.billNo;
      this.storesConsumeMasterArray.salesType = bulkrecord.salesType;
      this.storesConsumeMasterArray.doctorName = bulkrecord.doctername;
      this.totalAmount = bulkrecord.totalAmount;
      this.totalNetAmount = bulkrecord.netAmount;
      let selectedLocation = this.locationgetData.find(
        (loc) => loc.consumptionLocationName === bulkrecord.location
      );
      if (selectedLocation) {
        this.storesConsumeMasterArray.locationName = selectedLocation.consumptionLocationName || null;
        this.storesConsumeMasterArray.fK_ConsumeLocationID = selectedLocation.pK_ConsumptionLocationId
      }

      this.ipdService.getstoreConsumeDetails(bulkrecord.pK_ConsumeId).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
        const batchRequests = res.map(item => {
          let matchedItem = this.searchItemlist.find(it => it.pK_ItemID == item.fK_ItemId);
          if (matchedItem) {
            return this.ipdService.getBatchitem(this.deptId, matchedItem.pK_ItemID).pipe(
              map(batchRes => {
                let matchedBatch = batchRes.find(bt => bt.pK_BatchID == item.fK_BatchId);
                return {
                  ...item,
                  saleQuantity: item.consumeQty, // Mapping consumeQty -> saleQuantity
                  itemName: matchedItem.itemName,
                  itemCode: matchedItem.itemCode,
                  hsnno: matchedItem.hsnno,
                  unitName: matchedItem.unitName,
                  vatPercentage: matchedItem.vatPercentage,
                  batchNo: matchedBatch ? matchedBatch.batchNo : '',
                  expDate: matchedBatch ? matchedBatch.expDate : '',
                };
              })
            );
          } else {
            return of({
              ...item,
              saleQuantity: item.consumeQty,
              itemName: '',
              itemCode: '',
              hsnno: '',
              unitName: '',
              batchNo: '',
              expDate: '',
            });
          }
        });

        // forkJoin 
        forkJoin(batchRequests).pipe(takeUntil(this.destroybulk$)).subscribe(finalData => {
          // this.getstoretemData = this.getstoretemData.concat(finalData) 
          this.getstoretemData = finalData
          this.getstoretemData.forEach((res, index) => {
            // console.log(index,'called index')
            // this.saveedit(index,res)
            setTimeout(() => {
              this.saveedit(index, res);
            });
          })
        });
      });
      this.ipdService.getStoresConsumeMasterTracking(bulkrecord.pK_ConsumeId).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
        this.storesConsumeMasterTrackingarray = res[0]
      })
      this.ipdService.getStoresConsumeMaster(bulkrecord.pK_ConsumeId, 0, 0).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
        let matchedItem = this.payorNames.find(it => it.pkPartyId == res[0].fK_PartyId);
        this.storesConsumeMasterArray.payorname = matchedItem.partyName
        this.storesConsumeMasterArray.fK_PartyId = matchedItem.pkPartyId


      })
    }
    this.closeserchBulk();
  }


  barcodeSearch() {
    if (!this.barcodeQuery.trim()) {
      alert('Please enter a valid barcode!');
      return;
    }


    this.filteredbarcodeList = this.searchbarcodelist.filter(item =>
      item.batchNo.toLowerCase().includes(this.barcodeQuery.toLowerCase())
    );


    if (this.filteredbarcodeList.length > 0) {
      this.barcodeModel();
    } else {
      alert('No matching barcode found');
    }
  }

  barcodeModel() {
    document.getElementById("BarcodebulkListDisplay").style.display = "block";
  }
  closebarcodeListDisplay() {
    document.getElementById("BarcodebulkListDisplay").style.display = "none";
  }

  bulkSearchrecords = [];
  getSerchApi() {
    if (this.bulkStartDate && this.bulkEndDate) {
      this.ipdService.getSearchBulkApi(this.bulkStartDate, this.bulkEndDate, this.authService.Loggeduser.branchid, this.deptId).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
        // this.bulkSearchrecords = res;
        if (res.length > 0) {
          this.bulkSearchrecords = res.filter(item => item.salesType == 'BulkConsumption');
          this.filteredbulkArray = res.filter(item => item.salesType == 'BulkConsumption');
        } else {
          this.dashboardService.openSnackBar("Record Not Found", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar("Please Select date first", "OK");
    }
  }

  filteredbulkArray = [];
  // filter only Bill NO.....
  filterTable() {
    this.filteredbulkArray = this.bulkSearchrecords.filter((item) =>
      item.billNo?.toString().toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  ShowRecord() {
    this.getSerchApi();
  }
  selectbarcode(item: any) {
    const selectedBatchId = item.pK_BatchID;
    this.selecteditemStockQty = item.totalStockQty;
    this.selectedStockQty = item.stockQty;
    this.ipdService.getCommanBatchno(this.deptId, 0, selectedBatchId).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
      if (res && res.length > 0) {
        const selectedItem = res.find((element) => element.pK_BatchID === selectedBatchId);
        this.addedItems.push(selectedItem)
        const soterate = (selectedItem.mrp / (100 + selectedItem.vatPercentage)) * 100;
        selectedItem.rate = soterate;
        selectedItem.brate = soterate;
        selectedItem.saleQuantity = 1;
      }
    })
    document.getElementById("BarcodebulkListDisplay").style.display = "none";
  }
  storind: number = -1
  batchModel(item, index) {
    this.storind = index
    const dynamicItemId = item.fK_ItemId || item.pK_ItemID

    this.ipdService.getCommanBatchno(this.deptId, dynamicItemId, 0).pipe(takeUntil(this.destroybulk$)).subscribe(
      (batchData) => {
        this.getbatchnoData = batchData;
        if (this.getbatchnoData.length > 0) {
          document.getElementById("BatchnobulkListDisplay").style.display = "block";
        } else {
          this.dashboardService.openSnackBar("No Btach no. Available for this item", "OK");
        }
      },
      (error) => console.error('Error fetching batchnoItem:', error)
    );
  }

  closebatchNoListDisplay() {
    document.getElementById("BatchnobulkListDisplay").style.display = "none";
  }


  inputbatchModel(item, index) {
    this.storind = index
    const pkitemId = item.pK_ItemID;
    if (pkitemId) {
      this.ipdService.getCommanBatchno(this.deptId, pkitemId, 0).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
        this.getbatchnoData = res;
        document.getElementById("addbulkBatchnoListDisplay").style.display = "block";
      }, (error) => console.error('Error fetching batchnoItem:', error))
    }
  }

  selectBatchNo(item: any) {
    const soterate = (item.mrp / (100 + this.getstoretemData[this.storind].vatPercentage)) * 100;
    // this.searchbatchnoQuery = item.batchNo; 
    if (this.storind == 0 || this.storind) {
      this.getstoretemData[this.storind].batchNo = item.batchNo
      this.getstoretemData[this.storind].expDate = item.expDate
      this.getstoretemData[this.storind].pK_ItemID = item.pK_ItemID
      this.getstoretemData[this.storind].pK_BatchID = item.pK_BatchID
      this.getstoretemData[this.storind].mrp = item.mrp
      this.getstoretemData[this.storind].rate = soterate
      this.getstoretemData[this.storind].baseRate = soterate
    }
    document.getElementById("BatchnobulkListDisplay").style.display = "none";
  }

  baseAmount: any;
  selectBatchNoadd(item) {
    this.selectedStockQty = item.stockQty;
    const soterate = (item.mrp / (100 + this.addedItems[this.storind].vatPercentage)) * 100;
    this.addedItems[this.storind].batchNo = item.batchNo
    this.addedItems[this.storind].pK_BatchID = item.pK_BatchID
    this.addedItems[this.storind].expDate = item.expDate
    this.addedItems[this.storind].mrp = item.mrp;
    this.addedItems[this.storind].rate = soterate;
    this.addedItems[this.storind].brate = soterate

    this.addedItems[this.storind].netAmount = this.addedItems[this.storind].mrp * 1
    this.addedItems[this.storind].amount = this.addedItems[this.storind].rate * 1
    this.addedItems[this.storind].gstAmount = (this.addedItems[this.storind].amount * this.addedItems[this.storind].vatPercentage) / 100;


    document.getElementById("addbulkBatchnoListDisplay").style.display = "none";
    this.storind = -1
  }

  saleQuantitycal(index, item, type) {
    this.addedItems[index].netAmount = this.addedItems[index].mrp * item
    this.addedItems[index].amount = this.addedItems[index].rate * item
    if (type == '1') {
      this.addedItems[index].saleQuantity = item;
      this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;

      if (this.addedItems[index].discountAmount) {
        this.addedItems[index].netAmount = (this.addedItems[index].mrp * item) - this.addedItems[index].discountAmount
      }

      if (this.addedItems[index].discountPercentage) {
        this.addedItems[index].discountAmount = (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].mrp * this.addedItems[index].saleQuantity)
        this.addedItems[index].netAmount = (this.addedItems[index].mrp * this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount;
        this.addedItems[index].amount = (this.addedItems[index].rate * this.addedItems[index].saleQuantity) - (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].rate * this.addedItems[index].saleQuantity)
        this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;

      }
    }
    if (type == '2') {
      this.addedItems[index].discountPercentage = item;
      this.addedItems[index].discountAmount = (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].mrp * this.addedItems[index].saleQuantity)
      this.addedItems[index].netAmount = (this.addedItems[index].mrp * this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount
      this.addedItems[index].amount = (this.addedItems[index].rate * this.addedItems[index].saleQuantity) - (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].rate * this.addedItems[index].saleQuantity)
      this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;

    }

    if (type == '3') {
      this.addedItems[index].discountAmount = Number(item);
      this.addedItems[index].discountPercentage = (this.addedItems[index].discountAmount / (this.addedItems[index].mrp * this.addedItems[index].saleQuantity)) * 100;
      this.addedItems[index].netAmount = (this.addedItems[index].mrp * this.addedItems[index].saleQuantity) - this.addedItems[index].discountAmount;
      this.addedItems[index].amount = (this.addedItems[index].rate * this.addedItems[index].saleQuantity) - (this.addedItems[index].discountPercentage / 100) * (this.addedItems[index].rate * this.addedItems[index].saleQuantity)
      this.addedItems[index].gstAmount = (this.addedItems[index].amount * this.addedItems[index].vatPercentage) / 100;
    }
    if (this.addedItems[index].saleQuantity == 0) {
      this.addedItems[index].netAmount = 0;
      this.addedItems[index].amount = 0;
    }
  }
  calculateTotalNetAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalNetAmount = this.getstoretemData.reduce((acc, item) => acc + (item.netAmount || 0), 0);
    }
  }

  calculateTotalAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalAmount = this.getstoretemData.reduce((acc, item) => acc + (item.amount || 0), 0);
    }
  }

  totalGstAmount: number;
  calculateTotalGstAmount(): void {
    this.totalGstAmount = this.getstoretemData.reduce((acc, item) => acc + (item.gstAmount || 0), 0);
  }
  calculateTotaldiscountAmount(): void {
    this.discountAmount = this.getstoretemData.reduce((acc, item) => acc + (item.discountAmount || 0), 0);
  }

  uploadData() {
    let hasInvalidQuantity = this.addedItems.some(
      item => item.saleQuantity < 0 || item.saleQuantity === null || item.saleQuantity === undefined || item.saleQuantity === "" || item.saleQuantity == "0");
    if (hasInvalidQuantity) {
      this.dashboardService.openSnackBar("Consume quantity has to be greater than 0 for this item", "OK");
      return;
    }
    let hasInvalidBatchNumber = this.addedItems.some(
      item => !item.batchNo || item.batchNo === null || item.batchNo === undefined || item.batchNo.trim() === "");
    if (hasInvalidBatchNumber) {
      this.dashboardService.openSnackBar("Please select batch of  this item", "OK");
      return;
    }
    let checkSaleQuantity = this.addedItems.some(item => item.saleQuantity > this.selectedStockQty);
    if (checkSaleQuantity) {
      this.dashboardService.openSnackBar("Can't sale more than stock quantity in this batch", "OK");
      return;
    }
    let hasInvalidDiscount = this.addedItems.some(item => item.discountPercentage > 100);
    if (hasInvalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    let invalidDiscount = this.addedItems.some(item => item.discountPercentage < 0);
    if (invalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage has to be greater than 0 for this item", "OK");
      return;
    }
    this.getstoretemData = this.getstoretemData.concat(this.addedItems)
    // this.roundOffcalcualtion();
    this.calculateTotalNetAmount();
    this.calculateTotalAmount();
    this.calculateTotalGstAmount()
    this.calculateTotaldiscountAmount()
    document.getElementById("AddbulkConsumableItemsModal").style.display = "none";
    this.addedItems = [];
    this.getbatchnoData = [];
    // this.searchItemlist = [];
    this.selectedStockQty = 0;
    this.selecteditemStockQty = 0;
    this.isDepartmentSelected = false;
  }

  saleQuantityeditcal(index, item, type, data) {
    this.getstoretemData[index].netAmount = this.getstoretemData[index].mrp * item
    this.getstoretemData[index].amount = this.getstoretemData[index].rate * item
    if (type == '1') {
      this.getstoretemData[index].saleQuantity = item;
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
      // this.getstoretemData[index].amount = this.getstoretemData[index].amount - this.getstoretemData[index].gstAmount;
      if (this.getstoretemData[index].discountAmount) {
        this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * item) - this.getstoretemData[index].discountAmount
      }
      if (this.getstoretemData[index].discountPercentage) {
        this.getstoretemData[index].discountAmount = (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)
        this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount
        this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
        this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
      }
    }
    if (type == '2') {
      this.getstoretemData[index].discountPercentage = item;
      this.getstoretemData[index].discountAmount = (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    }
    if (type == '3') {
      this.getstoretemData[index].discountAmount = Number(item)
      this.getstoretemData[index].discountPercentage = (this.getstoretemData[index].discountAmount / (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)) * 100;
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    }

    if (this.getstoretemData[index].saleQuantity == 0) {
      this.getstoretemData[index].netAmount = 0;
      this.getstoretemData[index].amount = 0;
      this.getstoretemData[index].gstAmount = 0;
      this.getstoretemData[index].discountAmount = 0;
    }
    this.temEditcalcualtion(index, data)
  }

  updateEditCache(): void {
    this.getstoretemData.forEach((item, index) => {
      this.editCache[index] = {
        edit: false,
        data: { ...item },
      };
    });
  }
  isEditing: boolean = false;
  Edit(index, item) {
    // const dynamicItemId = item.fK_ItemId;
    this.updateEditCache();
    // this.editCache[index].edit = true;
    this.editCache[index] = { data: { ...item }, edit: true };
    this.isDepartmentSelected = false;
    this.isEditing = true;
  }

  calculateTotaltemNetAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalNetAmount = this.getstoretemData.reduce((acc, item) => acc + (item.netAmount || 0), 0);
    }
  }

  calculatetemTotalAmount() {
    if (this.getstoretemData && this.getstoretemData.length > 0) {
      this.totalAmount = this.getstoretemData.reduce((acc, item) => acc + (item.amount || 0), 0);
    }
  }

  updateTotalDiscount(index) {
    if (!this.discountAmount && this.getbatchnoData.length > 0) {
      this.discountAmount += this.getstoretemData.reduce((total, row) => {
        return total + row.discount; // Assuming each row has a 'discount' field
      }, 0);
    }
  }

  updateTotalGstAmount(index) {
    if (!this.totalGstAmount && this.getbatchnoData.length > 0) {
      this.totalGstAmount = this.getstoretemData.reduce((total, row) => {
        return total + row.vatAmount; // Assuming each row has a 'gstAmount' field
      }, 0);
    }
  }

  temEditcalcualtion(index, item) {
    this.getstoretemData[index].batchNo = item.batchNo
    this.getstoretemData[index].expDate = item.expDate
    if (item.batchid) {
      this.getstoretemData[index].fK_BatchId = item.batchid
    }
    this.getstoretemData[index].mrp = item.mrp
    this.getstoretemData[index].rate = item.rate
    this.getstoretemData[index].baseRate = item.baseRate

    // const saleQuantity = this.editCache[index].data.saleQuantity;
    const saleQuantity = item.saleQuantity
    this.getstoretemData[index].netAmount = this.getstoretemData[index].mrp * saleQuantity
    this.getstoretemData[index].amount = this.getstoretemData[index].rate * saleQuantity
    this.getstoretemData[index].discountPercentage = item.discountPercentage
    this.getstoretemData[index].discountAmount = item.discountAmount
    this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;

    if (this.getstoretemData[index].discountPercentage) {
      this.getstoretemData[index].discountAmount = (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    }

    if (this.getstoretemData[index].discountAmount) {
      this.getstoretemData[index].discountPercentage = (this.getstoretemData[index].discountAmount / (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity)) * 100;
      this.getstoretemData[index].netAmount = (this.getstoretemData[index].mrp * this.getstoretemData[index].saleQuantity) - this.getstoretemData[index].discountAmount;
      this.getstoretemData[index].amount = (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity) - (this.getstoretemData[index].discountPercentage / 100) * (this.getstoretemData[index].rate * this.getstoretemData[index].saleQuantity)
      this.getstoretemData[index].gstAmount = (this.getstoretemData[index].amount * this.getstoretemData[index].vatPercentage) / 100;
    }

    if (this.getstoretemData[index].saleQuantity == 0) {
      this.getstoretemData[index].netAmount = 0;
      this.getstoretemData[index].amount = 0;
    }
    // ** Calculate Total Net Amount **
    // this.roundOffcalcualtion();
    this.calculateTotaltemNetAmount();
    this.calculatetemTotalAmount();
    this.updateTotalDiscount(index);
    this.updateTotalGstAmount(index);
    this.calculateTotaldiscountAmount();
    this.calculateTotalGstAmount()
  }


  // Save the changes and exit edit mode
  saveedit(index: number, item): void {
    if (item.discountPercentage > 100) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    if (item.discountPercentage < 0) {
      this.dashboardService.openSnackBar("Discount percentage has to be greater than 0 for this item", "OK");
      return;
    }
    if (item.saleQuantity < 0 || item.saleQuantity == "0" || item.saleQuantity == "") {
      this.dashboardService.openSnackBar("Consume quantity has to be greater than 0 for this item", "OK");
      return;
    }
    this.getstoretemData[index] = item;
    this.isDepartmentSelected = false;
    this.temEditcalcualtion(index, item);
    this.editCache[index].edit = false;
    this.isEditing = false;
  }

  canceledit(index: number, item): void {
    this.getstoretemData[index] = { ...this.editCache[index].data };
    this.editCache[index].edit = false;
    this.temEditcalcualtion(index, this.getstoretemData[index]);
  }

  cleardata() {
    this.addedItems = [];
    this.selectedItem = [];
    this.batchNo = '';
    this.saleQuantity = null;
    this.discountPercentage = null;
    this.selectedStockQty = null;

  }
  clarecalculation() {
    this.totalAmount = 0;
    this.totalNetAmount = 0;
    this.gstAmount = 0;
    this.discountAmount = 0
    this.totalGstAmount = 0;
  }

  deleteminuscalculation(i) {
    if (this.getstoretemData[i]) {
      if (this.getstoretemData[i].netAmount) {
        this.totalNetAmount = this.totalNetAmount - this.getstoretemData[i].netAmount
      }
      if (this.getstoretemData[i].amount && this.getstoretemData[i]) {
        this.totalAmount = this.totalAmount - this.getstoretemData[i].amount
      }
      if (this.getstoretemData[i].gstAmount && this.getstoretemData[i]) {
        this.totalGstAmount = this.totalGstAmount - this.getstoretemData[i].gstAmount
      }
      if (this.getstoretemData[i].discountAmount) {
        this.discountAmount = this.discountAmount - this.getstoretemData[i].discountAmount
      }
    }
  }
  deleteArray = []
  deleteItem(item: any, i): void {
    if (item.fK_ConsumeId && item.fK_ConsumeId != 0) {
      this.getstoretemData[i].isEdit = true;
      this.getstoretemData[i].isDelete = true;

      this.deleteArray.push(
        this.getstoretemData[i]
      )
    }
    this.deleteminuscalculation(i)
    const index = this.getstoretemData.indexOf(item);
    if (index > -1) {
      this.getstoretemData.splice(index, 1);
    }
  }


  deleteItemrow(item: any) {
    const index = this.addedItems.indexOf(item);
    if (index > -1) {
      this.addedItems.splice(index, 1);
    }
  }

  deleterow(item) {
    const index = this.selectedItem.indexOf(item);
    if (index > -1) {
      this.selectedItem.splice(index, 1);
    }
  }

  addclosebatchNoListDisplay() {
    document.getElementById("addbulkBatchnoListDisplay").style.display = "none"
  }

  consumeid: any;
  consumeQty: any
  idx: any
  billNo: any;
  savebulkConsumtion() {
    if (this.getstoretemData.some(item => item.saleQuantity === null || item.saleQuantity == 0)) {
      this.dashboardService.openSnackBar("Consume quantity has to be greater than 0 for this item", "Ok")
      return;
    }

    let hasInvalidDiscount = this.getstoretemData.some(item => item.discountPercentage > 100);
    if (hasInvalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage cannot be greater than 100", "OK");
      return;
    }
    let invalidDiscount = this.getstoretemData.some(item => item.discountPercentage < 0);
    if (invalidDiscount) {
      this.dashboardService.openSnackBar("Discount percentage has to be greater than 0 for this item", "OK");
      return;
    }
    const checkBatchNo = this.getstoretemData.every(item => item.batchNo);
    const itemsWithoutBatchNo = this.getstoretemData.filter(item => !item.batchNo || item.batchNo.trim() === '').map(item => item.itemName);
    if (!checkBatchNo) {
      this.dashboardService.openSnackBar(`Please select batch of item ${itemsWithoutBatchNo}`, "OK");
      return;
    }
    if (!this.storesConsumeMasterArray.fK_PartyId) {
      this.dashboardService.openSnackBar("Please select payor name", "OK");
      return;
    }
    if (!this.patientCtrl?.value || this.patientCtrl.value.trim() === '') {
      this.dashboardService.openSnackBar("Please select Customer patient Consumed for Name", "OK");
      return;
    }

    const partyInput = this.storesConsumeMasterArray.salesType?.trim();
    if (!partyInput) {
      this.dashboardService.openSnackBar("Please Select Sales Type", "OK");
      return;
    }
    if (this.storesConsumeMasterArray.salesType !== 'BulkConsumption') {
      this.dashboardService.openSnackBar("Please Select Consumption Sales Type", "OK");
      return;
    }

    // if (this.isEditing) {
    //   this.dashboardService.openSnackBar("Please save or cancel the ongoing edits before proceeding", "OK");
    //   return;
    // }

    const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
    this.storesConsumeItemDetails = [];
    this.getstoretemData.forEach((item, index) => {
      this.idx = index
      if (item.fK_AltUnitId == item.fk_PrimaryUnitId) {
        this.consumeQty = item.saleQuantity
      } else {
        this.consumeQty = item.saleQuantity * item.conversionFactor
      }
      this.baseAmount = this.consumeQty * item.brate
      this.storesConsumeItemDetails.push({
        "pK_ConsumeDetailId": item.pK_ConsumeDetailId ? item.pK_ConsumeDetailId : 0,
        // "fK_ConsumeId": item.fK_ConsumeId ? item.fK_ConsumeId : 0,
        "fK_ConsumeId": this.fkconsumeId ? this.fkconsumeId : item.pK_ConsumeId ? item.pK_ConsumeId : 0,
        "fK_ItemId": item.pK_ItemID || item.fK_ItemId,
        "fK_GSTID": item.fK_VatSlabId,
        "fK_BatchId": item.pK_BatchID || item.fK_BatchId,
        "fK_PriceUnitId": item.fk_PrimaryUnitId,
        "indentQty": 0.0,
        "consumeQty": item.saleQuantity,
        "consumeQtyAlternateUnit": this.consumeQty,
        "mrp": item.mrp,
        "baseRate": item.brate ? item.brate : 0,
        "rate": item.rate,
        "baseAmount": this.baseAmount,
        "discountPer": item.discountPercentage ? item.discountPercentage : 0,
        "discountAmount": item.discountAmount ? item.discountAmount : 0,
        "amount": item.amount,
        "vatPer": item.vatPercentage,
        "vatAmount": item.gstAmount,
        "surchargePer": 0.0,
        "surchargeAmount": null,
        "totalTaxAmount": item.gstAmount,
        "netValue": item.netAmount,
        "remarks": item.remarks,
        "pK_DetailID": null,
        "pK_IndentDetailId": null,
        "purchasePrice": item.purchasePrice,
        "purchasePriceForTPA": 0,
        "isEdit": item.fK_ConsumeId ? true : false,
        "isDelete": false
      })
    })
    const storesConsumeMaster = {
      "pK_ConsumeId": this.fkconsumeId ? this.fkconsumeId : 0,
      "fK_BranchId": this.authService.Loggeduser.branchid,
      "fK_FinYearId": this.authService.Loggeduser.finyear,
      "fK_DeptId": this.deptId,
      "transactionType": "Receipt",
      "consumeType": this.ShowbulkDepName,
      "salesType": this.storesConsumeMasterArray.salesType,
      "billNo": this.billNo,
      "consumeDate": moment(currrentdate).format('YYYY-MM-DD'),
      "consumeTime": moment(currrentdate).format("HH:mm:ss"),
      "fK_IPDID": null,
      "fK_RegID": null,
      "fK_PartyId": this.storesConsumeMasterArray.fK_PartyId,
      "fK_VisitID": null,
      "patientName": this.storesConsumeMasterArray.patientName,
      "mobileNo": null,
      "doctorName": this.storesConsumeMasterArray.doctorName,
      "totalAmount": this.totalAmount,
      "discount": this.discountAmount,
      "gstAmount": this.totalGstAmount,
      "grossAmount": this.totalNetAmount,
      "roundOff": this.roundedOffAmount,
      "netAmount": this.totalNetAmount,
      "totalPaid": 0.0,
      "remarks": this.storesConsumeMasterArray.remarks,
      "deliveryDate": null,
      "isDelivered": null,
      "fK_CreatedbyId": this.authService.Loggeduser.userid,
      "createdDatetime": moment(currrentdate).format('YYYY-MM-DD') + 'T' + moment(currrentdate).format("HH:mm:ss"),
      "isActive": this.isActive,
      "fK_consumeId": this.fkconsumeId ? this.fkconsumeId : 0,
      "fK_BIllingCompanyId": this.authService.Loggeduser.billingcompanyid,
      "igN_Status": null,
      "fK_ConsumeLocationID": this.storesConsumeMasterArray.fK_ConsumeLocationID,
      "purchasePrice": this.getstoretemData[0]?.purchasePrice || 0,
      "fK_StateId": this.opdvisitService.stateid,
      "gstno": this.storesConsumeMasterArray.gstno,
      "shiftName": null,
      "isEdit": this.fkconsumeId ? true : false
    };
    const ConsumeMasterTracking = {
      "PK_TranId,": this.storesConsumeMasterTrackingarray.PK_TranId ? this.storesConsumeMasterTrackingarray.PK_TranId : 0,
      // "PK_TranId" : this.storesConsumeMasterTrackingarray?.pK_TranId ?? 0,
      // "pK_ConsumeId":  this.fkconsumeId ?  this.fkconsumeId : 0,
      "pK_ConsumeId": this.storesConsumeMasterTrackingarray.pK_ConsumeId ? this.storesConsumeMasterTrackingarray.pK_ConsumeId : 0,
      // "pK_ConsumeId":this.storesConsumeMasterTrackingarray?.pK_ConsumeId ?? 0,
      "fK_DeptId": this.deptId,
      "consumeType": this.ShowbulkDepName,
      "salesType": this.storesConsumeMasterArray.salesType,
      "billNo": this.billNo,
      "consumeDate": moment(currrentdate).format('YYYY-MM-DD'),
      "consumeTime": moment(currrentdate).format("HH:mm:ss"),
      "fK_IPDID": null,
      "fK_RegID": null,
      "fK_PartyID": this.storesConsumeMasterArray.fK_PartyId,
      "fK_VisitID": null,
      "patientName": this.storesConsumeMasterArray.patientName,
      "mobileNo": null,
      "doctorName": this.storesConsumeMasterArray.doctorName,
      "totalAmount": this.totalAmount,
      "discount": this.discountAmount,
      "gstAmount": this.totalGstAmount,
      "grossAmount": this.totalNetAmount,
      "roundOff": this.roundedOffAmount,
      "netAmount": this.totalNetAmount,
      "totalPaid": 0,
      "remarks": this.storesConsumeMasterArray.remarks,
      "fK_CreatedbyId": this.authService.Loggeduser.userid,
      "createdDatetime": moment(currrentdate).format('YYYY-MM-DD') + 'T' + moment(currrentdate).format("HH:mm:ss"),
      "fK_consumeId": this.fkconsumeId ? this.fkconsumeId : 0,
      "fK_BIllingCompanyId": this.authService.Loggeduser.billingcompanyid,
      "fK_ConsumeLocationID": this.storesConsumeMasterArray.fK_ConsumeLocationID,
      "fK_StateId": this.opdvisitService.stateid,
      "gstno": this.storesConsumeMasterArray.gstno,
      "shiftName": null,
      "ComputerName": null,
      "transactionType": "Receipt",
      "isEdit": this.fkconsumeId ? true : false
    }

    let payload = {
      StoresConsumeMaster: storesConsumeMaster,
      StoresConsumeMasterTracking: ConsumeMasterTracking,
      StoresConsumeItemDetail: this.storesConsumeItemDetails.concat(this.deleteArray),
    };
    this.ipdService.saveInsertStoresConsumeMaster(payload).pipe(takeUntil(this.destroybulk$)).subscribe(
      data => {
        if (data && data.statusCode === "1") {
          this.consumeid = data['id'];
          this.ipdService.getStoresConsumeMaster(this.consumeid, 0, 0).pipe(takeUntil(this.destroybulk$)).subscribe((res) => {
          })
          this.ipdService.getstoreConsumeDetails(this.consumeid).pipe(takeUntil(this.destroybulk$)).subscribe((res) => { console.log(res, 'called>>>>>2') })
          this.ipdService.getStoresConsumeMasterTracking(this.consumeid).pipe(takeUntil(this.destroybulk$)).subscribe((res) => { console.log(res, 'called>>>3') })
          // this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          this.dashboardService.openSnackBar(this.fkconsumeId ? "Record Updated Successfully" : "Record Saved Successfully", "OK");
          this.clearedata();
          this.isDepartmentSelected = true;
        }
        this.cleardata();
      },
      err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
          this.cleardata();
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  clearedata() {
    this.fkconsumeId = null;
    this.totalAmount = null;
    this.totalNetAmount = null;
    this.gstAmount = null;
    this.discountAmount = null;
    this.totalGstAmount = null;
    this.billNo = "";
    this.storesConsumeMasterArray.locationName = null;
    this.storesConsumeMasterArray.payorname = null;
    this.storesConsumeMasterArray.patientName = '';
    this.storesConsumeMasterArray.remarks = "";
    this.storesConsumeMasterArray.gstno = "";
    this.storesConsumeItemDetails = [];
    this.getstoretemData = [];
  }


  ngOnDestroy(): void {
    this.destroybulk$.next(true);
    this.destroybulk$.unsubscribe();
    this.getbulkdeparment = null;
    this.addedItems = null;
    this.getbatchnoData = null;
    this.searchItemlist = null;
    this.totalAmount = null;
    this.totalNetAmount = null;
    this.gstAmount = null;
    this.discountAmount = null;
    this.totalGstAmount = null;
    this.salesTypeControl1 = null;
    this.locationControl1 = null;
    this.gstCtrl = null;
    this.remarkCtrl = null;
    this.patientCtrl = null;
    this.payorControl1 = null;
    this.bulkdepartmentControl = null;
    this.doctorCtrl = null;
    this.filterbulkdeparment = null;
    this.bulkSearchrecords = null;
    this.filteredbulkArray = null;
  }


  closebulk() {
    // this.bulkdepartmentControl.disable();
    this.dialogRef.close();
    // this.getbulkdeparment = [];
  }
}
